<template>
    <v-container fluid>
        <v-row dense class="pb-0 pl-0">
            <v-col cols="12" lg="12">
                <v-card flat outlined class="cardClass">
                    <v-card-title>
                        {{ $t('labels.documentNearExpiration') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-simple-table fixed-header dense height="30vh" style="background-color: #ffffff">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-left" style="white-space: nowrap; font-size: 15px">
                                                    {{ $t('fields.seafarer') }}
                                                </th>
                                                <th class="text-left" style="white-space: nowrap; font-size: 15px">
                                                    {{ $t('fields.document') }}
                                                </th>
                                                <th class="text-left" style="white-space: nowrap; font-size: 15px">
                                                    {{ $t('fields.expirationDate') }}
                                                </th>
                                                <th class="text-center" style="white-space: nowrap; font-size: 15px">
                                                    {{ $t('fields.actions') }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="(item, key) in items"
                                                :key="key"
                                                :class="{'cursor-pointer': true}"
                                            >
                                                <td style="white-space: nowrap; font-size: 15px">
                                                    {{ item.seafarer.name }}
                                                    {{ item.seafarer.surname }}
                                                </td>
                                                <td style="white-space: nowrap; font-size: 15px">
                                                    {{ item.document_type.name }}
                                                </td>
                                                <td style="white-space: nowrap; font-size: 15px">
                                                    {{ item.date_of_expiry_display }}
                                                </td>
                                                <td style="white-space: nowrap" class="text-center">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{on, attrs}">
                                                            <v-icon
                                                                class="pl-2"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                @click="openSeafarerDocuments(item.seafarer_id)"
                                                                medium
                                                                >fas fa-user</v-icon
                                                            >
                                                        </template>
                                                        <span>{{ $t('tooltips.openSeafarerDocuments') }}</span>
                                                    </v-tooltip>
                                                    &nbsp;
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'DocumentsNearExpirationTable',
    components: {},
    data: function () {
        return {
            items: [],
        };
    },

    methods: {
        openSeafarerDocuments(seafarerId) {
            if (this.$myStore.state.user.user_role_id == 1) {
                let routeData = this.$router.resolve('/seafarers/' + seafarerId + '/2');
                window.open(routeData.href, '_blank');
            }
        },

        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall(
                'get',
                'documents-near-expiration',
                request,
                (data, success) => {
                    if (success) {
                        this.items = data.items;
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.reloadData();
    },
};
</script>

<style scoped>
.cardClass {
    border-width: 2px;
    border-color: #2c5282;
    background-color: #ffffff !important;
}
th {
    background-color: #ffffff !important;
}
</style>
